import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Avatar } from "@/components/Avatar";

const METHOD_LABEL = { google: "with Google", password: "with email & password" };

export const SignedInBanner = () => {
  const { user, logout } = useAuth();
  const switchAccount = async () => {
    await logout();
    window.location.replace("/login");
  };
  return (
    <div className="mm-card p-4 mb-6 flex items-center gap-3 border-2 border-mm-primary/30" data-testid="signed-in-banner">
      <Avatar url={user.photo_url} name={user.name} size={44} testId="signed-in-avatar" />
      <div className="min-w-0 flex-1">
        <div className="text-sm">Signed in as <b className="break-all" data-testid="signed-in-email">{user.email}</b></div>
        {METHOD_LABEL[user.signed_in_with] && <div className="text-xs text-mm-muted" data-testid="signed-in-method">{METHOD_LABEL[user.signed_in_with]}</div>}
      </div>
      <button className="mm-btn-ghost !py-2 !px-3 shrink-0 text-sm" onClick={switchAccount} data-testid="signed-in-switch"><LogOut size={15} /> Switch account</button>
    </div>
  );
};
